import { z } from 'zod'

/**
 * Nenhum campo é obrigatório. O consentimento tem default e os campos de
 * apresentação são opcionais por RF-10 — ausência é estado válido. String vazia
 * passa em `max`, então não é preciso uma união com `z.literal('')`, que tornava
 * a inferência opcional e quebrava o `zodResolver`.
 *
 * As tags não são validadas contra o vocabulário ativo de propósito: o cliente
 * reenvia o conjunto completo que exibe, incluindo tags que o produtor desativou
 * depois de o participante declará-las. Rejeitá-las aqui quebraria o ciclo de
 * releitura e regravação. A api valida o que importa — que a tag pertence ao
 * evento — e devolve 422.
 */
export const networkingFormSchema = z.object({
  networking_opt_in: z.boolean(),
  networking_tag_ids: z.array(z.number()),
  headline: z.string().max(120, 'Use no máximo 120 caracteres'),
  company: z.string().max(120, 'Use no máximo 120 caracteres'),
  job_title: z.string().max(120, 'Use no máximo 120 caracteres')
})

// Tipado por inferência local em vez de importar NetworkingFormValues de
// `./types`: types.ts já importa este schema, e o import de volta criaria um
// ciclo — type-only, mas ainda um ciclo.
export const emptyNetworkingForm: z.infer<typeof networkingFormSchema> = {
  networking_opt_in: false,
  networking_tag_ids: [],
  headline: '',
  company: '',
  job_title: ''
}
